import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { getCode, ResponseGetCode, SubmitGetCode } from './api/getCode';
import { Start } from './steps/Start';
import { Confirm } from './steps/Confirm';

export const Switcher = () => {
  const [isRegistered, setIsRegistered] = useState(false);
  const [email, setEmail] = useState('');
  const [screen, setScreen] = useState('start');

  const [code, setCode] = useState('');

  const mutationGetCode = useMutation({
    mutationFn: (data: SubmitGetCode) => getCode(data),
    onSuccess: (data: ResponseGetCode) => {
      setCode(data.token);
      setIsRegistered(data.isRegistered);

      setScreen('confirm');
    },
  });

  if (screen === 'start') {
    return (
      <Start
        onSubmit={email => {
          setEmail(email);
          mutationGetCode.mutate({ email });
        }}
      />
    );
  }

  return (
    <Confirm
      email={email}
      otp={code}
      isRegistered={isRegistered}
      onBack={() => setScreen('start')}
    />
  );
};
